import Heading from '@websrc/App/Components/Heading/Heading'
import { brand } from '@websrc/App/Helpers/brand'
import { useProductMeta } from '@websrc/Basket/useProductMeta'
import clsx from 'clsx'
import { styles, typography } from 'leds'
import React from 'react'

import { ProductInfoStockLabel } from '../StockLabel/StockLabel'

export interface ProductInfoHeaderProps {
  productNumber: string
  overrideBrand?: string
  show: boolean
  smallText?: boolean
  isTopOfPage?: boolean
}

export const ProductInfoHeader = ({
  productNumber,
  overrideBrand,
  show,
  smallText,
  isTopOfPage,
}: ProductInfoHeaderProps) => {
  const { grade, name, embargo_date, is_retired, product_status } = useProductMeta(productNumber)
  let brandName = brand.name
  if (!show) {
    return null
  }
  if (overrideBrand) brandName = overrideBrand

  return (
    <>
      <div
        className={styles({ display: 'flex', justifyContent: 'space-between', marginBottom: 10 })}
      >
        {Boolean(grade) && <p className={typography({ size: smallText ? 'sm' : 'md' })}>{grade}</p>}
        <ProductInfoStockLabel
          className={styles({ display: 'inline-block' })}
          productDetails={{
            valid_from_date: embargo_date,
            product_status,
            is_retired,
          }}
          show={true}
        />
      </div>
      <p className={typography(smallText ? { responsiveSize: 'xl' } : { size: 'xl2' })}>
        {brandName}
      </p>
      <Heading headline={name} level={isTopOfPage ? 1 : 2} size={'l'} />
      <p
        className={clsx(
          styles({ marginBottom: 25, color: 'grey9' }),
          typography({ size: smallText ? 'sm' : 'md' })
        )}
      >
        {productNumber}
      </p>
    </>
  )
}
